module.exports = __webpack_public_path__ + "img/onboarding.e6c210a.svg";